<template>
  <q-dialog v-model="confirm" persistent transition-show="fade" transition-hide="fade">
    <div class="hris-modal" style="max-width: 420px;">
      <q-form @submit="confirmDeletingTrainee">
        <div class="hris-modal-header">
          <div>
            <h2 class="hris-modal-title">Delete Trainee</h2>
            <p class="hris-modal-subtitle">This action cannot be undone. Do you want to continue?</p>
          </div>
        </div>
        <div class="hris-modal-footer">
          <q-btn unelevated class="hris-q-ghost" label="Cancel" v-close-popup></q-btn>
          <q-btn unelevated class="hris-q-primary" label="Confirm" type="submit"></q-btn>
        </div>
      </q-form>
    </div>
  </q-dialog>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

  data() {
    return {
      confirm:false,
      id:'',
    }
  },

  created(){
    this.eventHub.$on('deleteEmployee', this.deleteEmployee);
  },

  methods: {
   deleteEmployee:function(obj){
      this.id = obj.id
      this.confirm = obj.status
   },

   confirmDeletingTrainee:function(){
      var formData = new FormData()
      formData.append('id',this.id);
      axios.create({
       baseURL : this.apiUrl,
       headers : {'Authorization' : `Bearer ${this.token}`}
    }).post(`/mobile/pantry/trainee/delete`,formData)
     .then((response) => {
       this.confirm = false
       this.eventHub.$emit('refreshList');
     });
   }
}
}
</script>
<style lang="css" scoped>
</style>
